import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "waitlist",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-enrollment" */ "Admissions/features/Enrollment/components/Waitlist"
    ).then(m => m.default)
  ),
});
